import type { NotificationModel } from "@/features/notifications/api/models/NotificationModel";
import type { NotificationUnreadCountModel } from "@/features/notifications/api/models/NotificationUnreadCount";
import { useHTTP, useHTTPMutation, type HTTPResponse, type PaginatedResponseModel } from "@/lib/http";
import { useQueryClient, type InfiniteData, type MutationFunction } from "@tanstack/react-query";

export const useMarkAllNotificationsRead = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse, undefined> = () => {
		return http({
			method: "POST",
			url: "/notification/read-all",
			body: undefined
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: () => {
			queryClient.setQueryData<InfiniteData<PaginatedResponseModel<NotificationModel>>>(
				["notifications"],
				oldData => {
					if (!oldData) {
						return oldData;
					}

					return {
						...oldData,
						pages: oldData.pages.map(page => ({
							...page,
							results: page.results.map(notification => ({
								...notification,
								readAt: new Date().toISOString()
							}))
						}))
					};
				}
			);

			queryClient.setQueryData<NotificationUnreadCountModel>(
				["notificationUnreadCount"],
				(oldData) => {
					if (!oldData) {
						return oldData;
					}

					return {
						...oldData,
						unreadCount: 0
					};
				}
			);
		}
	});
};
